import type { Locale } from './translations'

// The same credit and license as MediaLicense on the server, which also embeds them in every image file.
export const MEDIA_CREDIT = '© Visit Augsburg • visitaugsburg.info'
export const MEDIA_LICENSE_NAME = 'CC BY 4.0'

export function mediaLicenseDeedUrl(locale: Locale): string {
  return `https://creativecommons.org/licenses/by/4.0/deed.${locale}`
}
